var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"superset-container"},[_c('iframe',{staticStyle:{"width":"100%","height":"100vh","border":"none"},attrs:{"src":_vm.iframeSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }